import React from "react";
import { Circle, useScaleFactor } from "arkh";

import { graphql, useFragment } from "react-relay";

export const WidgetTeamScheduleSectionHeaderStatusDot = React.memo(
  WidgetTeamScheduleSectionHeaderStatusDotC
);

function WidgetTeamScheduleSectionHeaderStatusDotC(props: { occasion: any }) {
  const occasion = useFragment(
    graphql`
      fragment WidgetTeamScheduleSectionHeaderStatusDot_routineOccasion on RoutineOccasion {
        status(calculateNoTasks: true)
        totalTaskExecutionCount
      }
    `,
    props.occasion
  );
  const sf = useScaleFactor();

  switch (occasion.status) {
    case "FUTURE":
      return <Circle size="dot" borderColor="neutral" borderWidth={1.5 * sf} />;
    case "REQUIRED_COMPLETED":
    case "COMPLETED":
      return <Circle size="dot" color="positive" />;
    case "NOT_COMPLETED":
      return <Circle size="dot" color="negative" />;
    case "IN_PROGRESS":
      return <Circle size="dot" borderColor="primary" borderWidth={1.5 * sf} />;
    case "IN_PROGRESS_EXPIRED":
      return <Circle size="dot" color="negative" />;
    case "NO_TASKS_COMPLETED":
      return <Circle size="dot" color="border-primary" />;
    default:
      return <Circle size="dot" color="surface" />;
  }
}
